import styled from 'styled-components';

export const FormContainer = styled.div`
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 5px;
  flex-direction: column;
  font-family: var(--raleway);
  padding: 32px 20px;
  position: relative;
`;

export const Title = styled.h3`
  color: var(--text-primary);
  font-family: var(--raleway);
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.4px;
  margin: 0;
`;

export const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const GroupHeaderWrapper = styled(HeaderWrapper)`
  padding: 12px 0 30px;
`;

export const Card = styled.div`
  background: var(--white);
  border-radius: 5px;
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  width: 100%;
`;

export const PanelContainer = styled.div`
  background-color: var(--white);
  border: 0;
  border-radius: 4px;
  box-shadow: var(--shadow-md);
  margin-top: 20px;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
`;

export const BasePanelHeader = styled.div`
  align-items: center;
  background-color: inherit;
  box-shadow: var(--shadow-md-strong);
  display: flex;
  font-family: var(--raleway);
  font-size: 18px;
  font-weight: 500;
  justify-content: space-between;
  padding: 12px 14px;
  user-select: none;
`;

export const BasePanelContent = styled.div`
  min-width: 0;
  overflow: hidden;
  padding: 0;
`;
